<template>
  <div class="error-kakuninn">
    <p>
      エラーが発生しました。<br />
      アプリのサービスページからもう一度お試しください。<br />
      ※繰り返しエラーが発生する場合は時間を空けて再度ご確認ください。
    </p>
    <!-- <p>エラーが発生しました。</p> -->
    <!-- <GoBackButton @click="goBack" /> -->
  </div>
</template>
<script>
// import GoBackButton from '@components/atoms/button/goBack/go-back-button.vue';

export default {
  name: "error-page",
  components: {},
  // methods: {
  //   goBack() {
  //     if (window.Android) {
  //       window.Android.closeWebView();
  //     } else {
  //       window.close();
  //     }
  //   }
  // }
};
</script>

<style src="./error-page.css"></style>
